import React, { useEffect, useState } from 'react';
import { usePrevious } from '../hooks';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { Button, Row, Col, List, Timeline } from 'antd';
import ReactTimeAgo from 'react-time-ago';
import JavascriptTimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import { LoadingSpinner } from './LoadingSpinner';
import {
  SyncOutlined,
  ScheduleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';

JavascriptTimeAgo.locale(en);


const Activity = ({
  activity,
  getActivities,
  markActivitiesAsRead,
  networkError,
}) => {

  const CEILING_INIT = 80;
  const CEILING_STEP_SIZE = 20;
  const [ceiling, setCeiling] = useState(CEILING_INIT);


  useEffect(() => { getActivities() }, []); // On mount, runs once


  const prevNetworkError = usePrevious(networkError);
  useEffect(()=>{
    if (prevNetworkError && !networkError) {
      getActivities();
    }
  }, [networkError]);


  const { activities, status } = activity;
  const isLoading = (status === 'loading');
  const isEmpty = (activities.length === 0);

  const emptyState = (
    <div className="empty__state">
      <ScheduleOutlined className="empty__state__icon mt-5 mb-3" />
      <Row>
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 20, offset: 2 }}
          md={{ span: 18, offset: 3 }}
          lg={{ span: 16, offset: 4 }}
          xl={{ span: 12, offset: 6 }}
        >
          <h5 className="my-3">No recent activities to show.</h5>
          <p>
            Keep building pages and generating leads.
            Your events feed will keep getting populated over time.
          </p>
        </Col>
      </Row>
      <Button
        type="primary" icon={<SyncOutlined />} className="my-4"
        onClick={() => getActivities()}
      >
        Refresh
      </Button>
    </div>
  );

  const renderActivityTimeline = (activity, index) => {
    const { id, urlsafe, object, verb, objectid, extra, created } = activity;

    return (
      <Timeline.Item
        key={index}
        label={<ReactTimeAgo className="text-muted" date={created/1000} />}
      >
        {`${object} ${verb}`}
      </Timeline.Item>
    );
  };

  let content = null;
  if (isLoading) {
    content = <LoadingSpinner />;
  }
  else {
    if (isEmpty) {
      content = emptyState;
    }
    else {
      const filteredActivities = activities.sort((a, b)=>(b.created - a.created)).slice(0, ceiling);

      content = (
        <div>

          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <div>Recent Activities</div>
            </div>
            <Button type="default" icon={<SyncOutlined />} onClick={() => getActivities()}>
              Refresh
            </Button>
          </div>

          <Timeline mode="left" >

            {filteredActivities.map((activity, index) => renderActivityTimeline(activity, index))}

            { (activities.length > ceiling) ? (
              <div className="text-center">
                <Button onClick={()=>{ setCeiling(ceiling+CEILING_STEP_SIZE)}}>Show more</Button>
              </div>
            ): null }

          </Timeline>

        </div>
      );
    }
  }

  return (
    <div className="app__activity">
      <Helmet>
        <title>Recent Activities</title>
      </Helmet>
      { content }
    </div>
  );
};

export { Activity };



// WEBPACK FOOTER //
// ./scripts/presentation/Activity.jsx